import { render, staticRenderFns } from "./refresh-restrict-policy.vue?vue&type=template&id=54d87ef2&scoped=true"
import script from "./refresh-restrict-policy.vue?vue&type=script&lang=js"
export * from "./refresh-restrict-policy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d87ef2",
  null
  
)

export default component.exports